type Props = {
  open: boolean;
  helperText?: string;
  helperLink?: string;
  /** When set with helperText, panel shows a Learn More control that opens the drawer. */
  hasDrawerContent?: boolean;
  onOpenDrawer?: () => void;
};

const VNHelperPanel = ({ open, helperText, helperLink, hasDrawerContent = false, onOpenDrawer }: Props) => {
  const showExternalLink = Boolean(helperLink && !hasDrawerContent);
  const showDrawerLink = Boolean(hasDrawerContent && helperText);

  if (!open || (!helperText && !showExternalLink && !showDrawerLink)) return null;

  return (
    <div className="vn-field-help__panel">
      <div className="vn-field-help__panel-inner">
        {helperText && <div className="vn-field-help__panel-text">{helperText}</div>}
        {showDrawerLink && (
          <button type="button" className="vn-field-help__learn-more" onClick={onOpenDrawer}>
            Learn More
          </button>
        )}
        {showExternalLink && (
          <a className="vn-field-help__learn-more" href={helperLink} target="_blank" rel="noopener noreferrer">
            Learn More
          </a>
        )}
      </div>
    </div>
  );
};

export default VNHelperPanel;
